<template>
  <div :style="pageCss" class="reportPage">
    <ReportHeader v-if="header && header.visible" :key="reportDef.id + '_header'" :orientation="orientation" :header="header"></ReportHeader>
    <ReportLine v-if="header && header.visible" :style="afterHeaderCss"></ReportLine>
    <ReportBody v-if="body && body.visible" :key="reportDef.id + '_body'" :orientation="orientation" :body="body" :pageHeader="pageHeader" :pageFooter="pageFooter"></ReportBody>
    <ReportLine v-if="body && body.visible" :style="afterBodyCss"></ReportLine>
    <ReportFooter v-if="footer && footer.visible" :key="reportDef.id + '_footer'" :orientation="orientation" :footer="footer"></ReportFooter>
  </div>
</template>
<script>
  import ReportHeader from './ReportHeader'
  import ReportBody from './ReportBody'
  import ReportFooter from './ReportFooter'
  import ReportLine from './ReportLine'
  export default {
    name: 'ReportPage',
    props: ['orientation', 'reportDef'],
    components: {
      ReportHeader,
      ReportBody,
      ReportFooter,
      ReportLine
    },
    data () {
      return {
        text: '',
        pageWidth: this.reportDef ? this.reportDef.page.paper_size.inches[0] : 8.5,
        pageHeight: this.reportDef ? this.reportDef.page.paper_size.inches[1] : 11,
        pos: { top: 1, left: 1, width: 3, height: 3 }
      }
    },
    mounted () {
      console.log('ReportPage mounted...')
    },
    updated () {
      console.log('ReportPage updated...')
    },
    computed: {
      resizeCss () {
        return {
          position: 'absolute',
          top: this.pos.top + 'in',
          left: this.pos.left + 'in',
          width: this.pos.width + 'in',
          height: this.pos.height + 'in',
          backgroundColor: 'yellow',
          border: '1px dotted rgba(0,0,0,0.5)',
          zIndex: 0,
          fontSize: '14px'
        }
      },
      contentWidth () {
        if (this.reportDef && this.reportDef.page && this.reportDef.page.margins) {
          return this.pageWidth - this.reportDef.page.margins.left - this.reportDef.page.margins.right
        } else {
          return this.pageWidth
        }
      },
      contentHeight () {
        if (this.reportDef && this.reportDef.page && this.reportDef.page.margins) {
          return this.pageHeight - this.reportDef.page.margins.top - this.reportDef.page.margins.bottom
        } else {
          return this.pageHeight
        }
      },
      pageMargins () {
        if (this.reportDef && this.reportDef.page && this.reportDef.page.margins) {
          return this.reportDef.page.margins.top + 'in ' + this.reportDef.page.margins.right + 'in ' + this.reportDef.page.margins.bottom + 'in ' + this.reportDef.page.margins.left + 'in'
        } else {
          return '0in 0in 0in 0in'
        }
      },
      pageCss () {
        return {
          position: 'absolute',
          // backgroundColor: '#ddd',
          width: this.contentWidth + 'in',
          height: this.contentHeight + 'in',
          // padding: '0.5in',
          margin: this.pageMargins
        }
      },
      header () {
        if (this.reportDef && this.reportDef.header) {
          this.reportDef.header.width = this.contentWidth
          this.reportDef.header.top = 0
          this.reportDef.header.left = 0
          return this.reportDef.header
        } else {
          return null
        }
      },
      pageHeader () {
        if (this.reportDef && this.reportDef.page_header) {
          this.reportDef.page_header.width = this.contentWidth
          this.reportDef.page_header.height = 1
          this.reportDef.page_header.top = 0
          this.reportDef.page_header.left = 0
          return this.reportDef.page_header
        } else {
          return null
        }
      },
      body () {
        if (this.reportDef && this.reportDef.body) {
          this.reportDef.body.width = this.contentWidth
          let heightHeaderFooter = 0
          heightHeaderFooter += this.reportDef.header.visible ? this.reportDef.header.height : 0
          heightHeaderFooter += this.reportDef.footer.visible ? this.reportDef.footer.height : 0
          this.reportDef.body.height = this.contentHeight - heightHeaderFooter
          this.reportDef.body.top = this.reportDef.header.top + this.reportDef.header.height
          this.reportDef.body.left = 0
          return this.reportDef.body
        } else {
          return null
        }
      },
      footer () {
        if (this.reportDef && this.reportDef.footer) {
          this.reportDef.footer.width = this.contentWidth
          this.reportDef.footer.height = 1
          this.reportDef.footer.top = this.reportDef.body.top + this.reportDef.body.height
          this.reportDef.footer.left = 0
          // return this.reportDef.footer
          return this.pageFooter
        } else {
          return null
        }
      },
      pageFooter () {
        if (this.reportDef && this.reportDef.page_footer) {
          this.reportDef.page_footer.width = this.contentWidth
          this.reportDef.page_footer.height = 1
          this.reportDef.page_footer.top = this.reportDef.body.top + this.reportDef.body.height
          this.reportDef.page_footer.left = 0
          return this.reportDef.page_footer
        } else {
          return null
        }
      },
      afterHeaderCss () {
        return {
          top: this.reportDef.body.top + 'in',
          width: this.contentWidth + 'in',
          zIndex: 1000
        }
      },
      afterBodyCss () {
        return {
          top: this.reportDef.footer.top + 'in',
          width: this.contentWidth + 'in',
          zIndex: 1100
        }
      }
    },
    watch: {
      orientation (val) {
        console.log('this.orientation = ' + val)
        this.pageWidth = this.reportDef.page.paper_size.inches[0]
        this.pageHeight = this.reportDef.page.paper_size.inches[1]
        // this.afterHeaderCss.top = this.reportDef.body.top + 'in'
        // this.afterBodyCss.top = this.reportDef.footer.top + 'in'
        this.$forceUpdate()
      },
      '$parent.orientation' (val) {
        console.log('$parent.orientation = ' + val)
      },
      'reportDef.page.paper_size.inches' (val) {
        console.log('reportDef.page.paper_size.inches = ' + val)
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// ReportPage.vue?e2adfb88